import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "number",
  "title",
  "manufacturer",
  "models",
  "issue",
  "issue_date",
  "revision",
  "revision_date",
  "tasks",
  "aircraft",
  "updated",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const DEFAULT_COLUMNS: Column[] = [...COLUMNS]

export const COLUMN_LABELS: Record<Column, string> = {
  number: "Program no.",
  title: "Program",
  manufacturer: "Manufacturer",
  models: "Models",
  issue: "Issue",
  issue_date: "Issue date",
  revision: "Revision",
  revision_date: "Rev. date",
  tasks: "Tasks",
  aircraft: "Aircraft",
  updated: "Updated",
}

export type Slot = Column | "select" | "actions"

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "maintenance-programmes",
  widths: {
    number: 5,
    title: 15,
    manufacturer: 9.5,
    models: 11.5,
    issue: 5,
    issue_date: 6,
    revision: 5,
    revision_date: 6,
    tasks: 4.5,
    aircraft: 4.5,
    updated: 6,
    select: 2.25,
    actions: 3.25,
  },
  fill: "title",
  pinned: ["select", "actions"],
  extras: ["select", "actions"],
  dropOrder: [
    "issue_date",
    "revision_date",
    "manufacturer",
    "aircraft",
    "updated",
    "issue",
    "models",
    "tasks",
    "revision",
  ],
}

export function slotsOf(columns: Column[]): Slot[] {
  return ["select", ...columns, "actions"]
}

export function withNumber(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => column === "number" || columns.includes(column),
  )
}
